import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close-thin",
  "use": "close-thin-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"close-thin\"><path d=\"M4.821 5.472L.418 1.068l.707-.707 4.403 4.403L9.932.361l.707.707-4.403 4.404 4.403 4.403-.707.707L5.528 6.18l-4.403 4.403-.707-.707L4.82 5.472z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol